var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "container",
      staticClass: "slider-container",
      class: { "slider-visible": _vm.visible },
      style: { "z-index": _vm.zIndex },
      attrs: {
        role: "dialog",
        "aria-modal": "true",
        "aria-expanded": _vm.visible
      },
      on: {
        keydown: function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")
          ) {
            return null
          }
          return _vm.hide($event)
        }
      }
    },
    [
      _c(
        "div",
        {
          ref: "content",
          staticClass: "slider-content",
          class: _vm.mySide,
          style:
            "width:" +
            _vm.pixelWidth +
            "px;" +
            _vm.side +
            ":" +
            _vm.offset +
            "px; top:" +
            _vm.mytop +
            _vm.myLengthUnit +
            "; bottom:" +
            _vm.mybottom +
            _vm.myLengthUnit +
            ";"
        },
        [
          _c(
            "div",
            {
              directives: [{ name: "sticky", rawName: "v-sticky" }],
              ref: "header",
              staticClass: "slider-header",
              class: { offset: _vm.mytop > 0, twoLine: _vm.subTitle },
              style: _vm.headerStyle,
              attrs: { "sticky-offset": _vm.stickyOffset }
            },
            [
              _vm._t("head"),
              _vm._v(" "),
              _c("div", { staticClass: "slider-header-container" }, [
                _vm.headerImgSrc
                  ? _c("img", { attrs: { src: _vm.headerImgSrc } })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "slider-header-title-container" },
                  [
                    [
                      _c("span", {
                        staticClass: "title",
                        domProps: { innerHTML: _vm._s(_vm.title) }
                      }),
                      _vm._v(" "),
                      _vm.subTitle
                        ? _c("span", {
                            staticClass: "subTitle",
                            domProps: { innerHTML: _vm._s(_vm.subTitle) }
                          })
                        : _vm._e()
                    ]
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _vm.canClose && _vm.closeButton
                ? _c("f9button", {
                    ref: "close",
                    staticClass: "close-icon",
                    class: { closeIconTop: _vm.subTitle },
                    attrs: { nostyle: "", "aria-label": "Close" },
                    on: { click: _vm.hide }
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "body",
              staticClass: "slider-body",
              class: {
                "dd-upsell-height-auto":
                  _vm.applyDDUpsellCustomStyle && !this.isMobileView()
              },
              style: { padding: _vm.bodyPadding }
            },
            [
              _vm._t("default", null, {
                show: _vm.show,
                hide: _vm.hide,
                visible: _vm.visible
              })
            ],
            2
          )
        ]
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "slider-modal-top",
        style: { height: _vm.mytop + _vm.myLengthUnit },
        on: { click: _vm.hide }
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "slider-modal",
        style: { opacity: _vm.modalOpacity },
        on: { click: _vm.hide }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-123338a2", { render: render, staticRenderFns: staticRenderFns })
  }
}